var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"chart"},[(_vm.isEmpty)?_c('p',[_vm._v("Нет данных для данного набора фильтров")]):_vm._e(),_c('Doughnut',{ref:"chartCmp"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }